import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "cashier/tables"
const options = {role: ROLE.CASHIER};
const splitPaymentPath = (orderId) => {
    if (!orderId) throw new Error("splitPaymentPath: order_id is required");
    return `${path}/orders/${orderId}/split-payment`;
}

export const list = async (values ) => {
    return await axiosInstance(options).post(`${path}/list` , values);
}

export const detail = async (values) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${values.o_id}`, values);
}

export const categoryList = async (values ) => {
    return await axiosInstance(options).get(`${path}/categoriesList` , values);
}

export const categoryDetail = async (values) => {
    return await axiosInstance(options).get(`${path}/categoryDetail?o_id=${values.o_id}`, values);
}

export const menuList = async (values ) => {
    return await axiosInstance(options).post(`${path}/menuList` , values);
}

export const subCategoryList = async (values) => {
    return await axiosInstance(options).post(`${path}/subCategoryList`, values);
}

export const PaymentMethodList = async (values ) => {
    return await axiosInstance(options).post(`${path}/paymentMethodlist` , values);
}

export const getRestaurantSettings = async () => {
    return await axiosInstance(options).get(`${path}/restaurant-settings`)
}
  

export const payByCash = async (values) => {
    return await axiosInstance(options).post(`${path}/pay-by-cash` , values);
}

export const updateCustomerInfo = async (values ) => {
    return await axiosInstance(options).post(`${path}/update-customer-info` , values);
}


export const applyGiftCard = async (values ) => {
    return await axiosInstance(options).post(`${path}/apply-gift-card` , values);
}


export const removeGiftCard = async (values ) => {
    return await axiosInstance(options).get(`${path}/remove-gift-card?order_id=${values.order_id}` , values);
}

export const removeServiceCharge = async (values ) => {
    return await axiosInstance(options).get(`${path}/remove-service-charge?order_id=${values.order_id}`);
}


export const transactionDetail = async (values ) => {
    const printParam = values.printReceipt ? '&print=true' : '';
    // identifies WHICH payment of a split order this receipt is for. Without it the
    // backend can only build a whole-order receipt, so a partial payment reprinted
    // before the order is settled came out as a final receipt.
    const transactionParam = values.transaction_id ? `&transaction_id=${values.transaction_id}` : '';
    return await axiosInstance(options).get(`${path}/transaction-detail?o_id=${values.o_id}&type=${values.type}${printParam}${transactionParam}`, values);
}

export const orderDetail = async (values ) => {
    return await axiosInstance(options).get(`${path}/order-detail?o_id=${values.o_id}`, values);
}

export const receiptDetail = async (values ) => {
    return await axiosInstance(options).get(`${path}/receipt`, values);
}



export const applyCouponCode = async (values ) => {
    return await axiosInstance(options).post(`${path}/apply-coupon-code` , values);
}


export const removeCouponCode = async (values ) => {
    return await axiosInstance(options).get(`${path}/remove-coupon-code?order_id=${values.order_id}` , values);
}

export const getKitchenPrintHtml = async (values , option ) => {
    return await axiosInstance({extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}}).get(`${path}/kitchen-print?table_id=${values.tableId}&type=${values.type}`);
}

// WRDS-965: send only the not-yet-sent items of the open order to the kitchen.
export const sendToKitchen = async (values ) => {
    return await axiosInstance(options).post(`${path}/send-to-kitchen` , { table_id: values.tableId });
}

export const printTableSlip = async (values ) => {
    return await axiosInstance(options).post(`${path}/print-table-slip` , { table_id: values.tableId });
}

export const updateServiceCharge = async (values ) => {
    return await axiosInstance(options).put(`${path}/update-service-charge?order_id=${values.order_id}`, values);
}


export const addNewMenuItem = async (values ) => {
    return await axiosInstance(options).post(`${path}/add-new-item` , values);
}

export const searchCustomItems = async ({query, field = "both", limit = 20, signal}) => {
    const params = new URLSearchParams({
        q: query.trim(),
        field,
        limit: String(limit),
    });
    return await axiosInstance(options).get(`${path}/custom-items/autocomplete?${params.toString()}`, {signal});
}

// resolves a set menu's choice groups (which curries make up the set) so the
// cashier can pick each component, same endpoint the tablet cashier uses
export const menuItemDetails = async (values ) => {
    return await axiosInstance(options).post(`${path}/menu-item-details` , values);
}

export const deleteMenuItem = async (values ) => {
    return await axiosInstance(options).post(`${path}/delete-item` , values);
}

export const updateMenuItem = async (values ) => {
    return await axiosInstance(options).post(`${path}/update-item` , values);
}

export const updateNetworkSetting = async (values ) => {
    return await axiosInstance(options).put(`${path}/update-network` , values);
}

export const splitBilling = async (values) => {
    return await axiosInstance(options).post(splitPaymentPath(values.order_id), values);
}

export const previewSplitBilling = async (values) => {
    return await axiosInstance(options).post(`${splitPaymentPath(values.order_id)}/preview`, values);
}

export const getSplitPaymentStatus = async (orderId) => {
    return await axiosInstance(options).get(splitPaymentPath(orderId));
}

export const spiceLevelsOptions = async (values) => {
  return await axiosInstance(options).get(`${path}/spice-levels-options`, values);
}
